/* v8 ignore start */
import {type ClassValue, clsx} from "clsx";
import {twMerge} from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export namespace Utils {
  export function isDeepEqual(a: any, b: any): boolean {
    if (a === b || (a !== a && b !== b)) return true;
    if (!a || !b || !(a instanceof Object) || a.constructor !== b.constructor || a instanceof Function) return false;
    if (a instanceof Date || a instanceof RegExp) return a.toString() === b.toString();

    const aKeys = Object.keys(a);
    const aKeysCount = aKeys.length;

    if (aKeysCount !== Object.keys(b).length) {
      return false;
    }

    for (const key of aKeys) {
      if (!Object.prototype.hasOwnProperty.call(b, key) || !isDeepEqual(a[key], b[key])) return false;
    }

    return true;
  }

  export function isShallowEqual(a: any, b: any): boolean {
    if (!(a instanceof Object) || !(b instanceof Object)) return a == b;

    return (
      Object.keys(a).length === Object.keys(b).length &&
      Object.keys(a).every((key) => Object.prototype.hasOwnProperty.call(b, key) && a[key] === b[key])
    );
  }

  export function debounce<T extends (...args: any[]) => void>(
    func: T,
    delay: number
  ): (...args: Parameters<T>) => void {
    let timeoutId: ReturnType<typeof setTimeout>;

    return function (this: ThisParameterType<T>, ...args: Parameters<T>): void {
      clearTimeout(timeoutId);

      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
}
/* v8 ignore stop */
